import axios from "axios";
import { getApiHeaders } from "../../api/apiHeaders";
//import { I18n } from "react-redux-i18n";
import {
    OPTIONTRADE_LIST_ATTEMPT,
    OPTIONTRADE_LIST_SUCCESS,
    OPTIONTRADE_LIST_FAILED,
    ////////////////////

} from "../types/optionTradeTypes";
import { config } from "../../config";
const url_api = config.api.web;

export function loading() {
    return {
        type: OPTIONTRADE_LIST_ATTEMPT
    };
}

export function success(data) {
    return {
        type: OPTIONTRADE_LIST_SUCCESS,
        data: data
    };
}

export function failed(error) {
    return {
        type: OPTIONTRADE_LIST_FAILED,
        error: error
    };
}

export const loadList = (data: Object) => async dispatch => {
    dispatch(loading());
    await axios
        .get(url_api + "optiontrade/", {
            params: data.params,
            headers: getApiHeaders(),
        })
        .then(function (response) {
            //console.log(response);
            if (response.status < 300) {
                if (response.data.status === 'Success')
                    dispatch(success(response.data.body));
                else dispatch(failed(response.data.body));
            } else {
                dispatch(failed("try_later"));
            }
        })
        .catch(function (error) {
            console.log(error);
            if (error.Error) {
                dispatch(failed("try_later"));
            } else {
                dispatch(failed("try_later"));
            }
            return;
        });
};

/** Market GEX (chain OI + gamma) for Portfolio GEX tab. */
export const loadGex = ({ symbol, expiration } = {}) => async () => {
    const response = await axios.get(url_api + "optiontrade/gex", {
        params: {
            symbol: symbol || "SPY",
            ...(expiration ? { expiration } : {}),
        },
        headers: getApiHeaders(),
    });
    if (response.status < 300 && response.data?.status === "Success") {
        return response.data.body;
    }
    throw new Error(response.data?.body || "try_later");
};